import React from "react";
import { Link, useLocation } from "react-router-dom";
import { MapPin, Phone, Globe, Clock } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { SECTIONS } from "../../lib/directory";

const Avail = ({ on, icon: Icon, label }) => (
  <span title={label} className={`inline-flex items-center gap-1 ${on ? "text-white/70" : "text-white/20 line-through"}`}>
    <Icon size={12} /> {label}
  </span>
);

export const BusinessCard = ({ b, categoryName }) => {
  const { t } = useLang();
  const { search } = useLocation();
  const place = b.neighborhood_name;
  return (
    <Link to={`${SECTIONS[b.section].path}/${b.slug}`} state={{ fromSearch: search }} data-testid={`business-card-${b.slug}`}
      className="group block rounded-2xl bg-surface/60 border border-white/[0.06] p-5 hover:border-gold/30 hover:-translate-y-0.5 transition-[transform,border-color] duration-300">
      <div className="text-[11px] uppercase tracking-[0.18em] text-gold/75">{categoryName || b.category}</div>
      <div className="font-display text-lg text-white mt-1.5 group-hover:text-gold transition-colors duration-200 line-clamp-2">{b.name}</div>
      <div className="flex items-center gap-1.5 text-sm mt-1.5 text-white/55">
        <MapPin size={13} className="shrink-0" />
        <span className={place ? "" : "italic text-white/35"}>{place || t("directory.location_unavailable")}</span>
      </div>
      {b.cuisine?.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-3">
          {b.cuisine.slice(0, 3).map((c) => (
            <span key={c} className="text-[11px] px-2 py-0.5 rounded-full bg-white/[0.05] border border-white/10 text-white/60 capitalize">{c}</span>
          ))}
        </div>
      )}
      <div className="flex flex-wrap gap-3 mt-4 text-[11px]">
        <Avail on={b.has_phone} icon={Phone} label={t("directory.phone")} />
        <Avail on={b.has_website} icon={Globe} label={t("directory.website")} />
        <Avail on={b.has_hours} icon={Clock} label={t("directory.hours")} />
      </div>
    </Link>
  );
};
